module.exports = __webpack_public_path__ + "static/nigala-logo.3e193ba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nigala-logo.jpg
// module id = 188
// module chunks = 168707334958949